<template>
    <div :class="['card', { 'card-selected': isSelected, 'card-disabled': isDisabled }]" >
        <div 
            class="image" 
        >
            <ui-image 
                :src="imageComputed" 
                design="circle border-lg" 
                h="36" w="36" 
            />
        </div>
        <div class="description-content">
            <div class="description-user-container">
                <span class="name-text">{{ user.name }}</span>
                <span :class="['group-text', {'group-text-selected': isSelected}]">{{ user.group }}</span>
            </div>
            <div class="deals-number-container">
                <span class="deals-number">{{ user.count }} {{ user.count > 1 ? "negócios" : "negócio" }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { uiImage } from '@/components/ui';
import helpers from '@/mixins/helpers';

	export default {
		name: 'ui-responsible-card',

        components:{
            uiImage
        },

        mixins: [helpers],

		props: {
			user: {
                required: true,
                type: Object
            },
            isSelected: {
                type: Boolean,
                required: true
            },
            isDisabled: {
                type: Boolean,
                default: false
            }
		},

		data() {
			return {
			}
		},

		computed: {
			imageComputed() {
               return this.getImgCDN(this.user.photo)
            }, 
		},

		methods: {
			
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
